import {DestroyRef, Injectable, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Router} from '@angular/router';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {filter, take} from 'rxjs';

@Injectable({providedIn: 'root'})
export class SingleLogoutService {
  private readonly oidc = inject(OidcSecurityService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private started = false;

  start(): void {
    if (this.started) return;
    this.started = true;
    this.oidc.checkSessionChanged$.pipe(
      // The BehaviorSubject initially emits false; that is not a logout.
      filter(changed => changed === true),
      take(1),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(() => {
      this.oidc.logoffLocal();
      try { sessionStorage.removeItem('acfs.auth.return-url'); } catch { /* Storage may be disabled. */ }
      void this.router.navigateByUrl('/logout');
    });
  }
}
